import { createFileRoute } from '@tanstack/react-router';
import { GoalStep } from '@/pages/workspaces/broadcasts/newsletter/setup/goal/goal-step';
import { withRumPageRendered } from '@/services/rum/use-page-rendered';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/setup/tracking',
)({ component: withRumPageRendered(GoalStep) });
